import React from "react";

function ProductDetailsCard({ data }) {
  return (
    <div className="product-detail-content">
      <span className="new-arrival-content pr">
        FDRPDT{data.id}
      </span>{" "}
      <div className="new-arrival-content pr">
        <div
          className="d-flex align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <h3 style={{ textTransform: "capitalize" }}>
            {data.name}
          </h3>
          {data.product_commission && (
            <h4>{`commission ${data.product_commission}`}</h4>
          )}
        </div>

        <div className="d-flex mb-3">
          {data.is_recommended && (
            <div className="mx-1 tab-green tab-rounded p-1 ">
              <p className="m-0 tab-font-white">
                Recommended
              </p>
            </div>
          )}

          {data.is_popular && (
            <div className="mx-1 tab-black tab-rounded p-1">
              <p className="m-0 tab-font-white">Popular</p>
            </div>
          )}

          {data.is_new && (
            <div className="mx-1 tab-blue tab-rounded p-1">
              <p className="m-0 tab-font-white">New</p>
            </div>
          )}
        </div>
        <p>
          {data.is_out_of_stock && (
            <h6
              className="item bg-primary p-1 ml-1 my-3"
              style={{
                width: "max-content",
                color: "white",
              }}
            >
              Out of Stock
            </h6>
          )}
        </p>
      </div>
    </div>
  );
}

export default ProductDetailsCard;
